import { ReviewRatingClass, ReviewRatingFilters } from 'modules/review/review.enum';
import { ApiSortingDirection } from 'interfaces/api.interface';

export const getRatingClass = (filter?: ReviewRatingFilters): ReviewRatingClass | undefined => {
    switch (filter) {
        case ReviewRatingFilters.NEGATIVE:
            return ReviewRatingClass.NEGATIVE;
        case ReviewRatingFilters.NEUTRAL:
            return ReviewRatingClass.NEUTRAL;
        case ReviewRatingFilters.POSITIVE:
            return ReviewRatingClass.POSITIVE;
    }

    return undefined;
};

export const parseSorting = (sorting: string): { sortingField: string; sortingDirection: ApiSortingDirection; } | null => {
    if (!sorting) {
        return null;
    }

    const params = sorting.split(':');

    return {
        sortingField: params[0],
        sortingDirection: params[1] === ApiSortingDirection.desc ? ApiSortingDirection.desc : ApiSortingDirection.asc
    };
};
